import "../../Styles/Presence.css";

/**
 * Hur lång tid det tar att komma dit.
 *
 * Tre val och inget fält att skriva i. Ingen vet på minuten hur lång tid
 * det tar, och den som väntar behöver inte exakthet — den behöver veta om
 * det är "strax" eller "en halvtimme". Servern accepterar 1–180 minuter,
 * så valen ligger med god marginal innanför.
 */
export const ETA_CHOICES = [10, 20, 30] as const;

type Props = {
  label?: string;
  disabled?: boolean;
  selected?: number | null;
  onPick: (minutes: number) => void;
};

export default function EtaPicker({ label, disabled, selected, onPick }: Props) {
  return (
    <div className="eta-picker">
      {label && <span className="eta-picker-label">{label}</span>}

      <div className="eta-picker-options">
        {ETA_CHOICES.map((minutes) => (
          <button
            key={minutes}
            type="button"
            className={`eta-option ${selected === minutes ? "is-selected" : ""}`}
            disabled={disabled}
            aria-pressed={selected === minutes}
            onClick={() => onPick(minutes)}
          >
            {minutes} min
          </button>
        ))}
      </div>
    </div>
  );
}
